import React, { useRef } from 'react'
import { BarChart, CartesianGrid, ResponsiveContainer } from 'recharts'

import { ChartTooltip, XAxis, YAxis, Bar } from '../../components'
import { useBarChartHoverIndex, useBarSize, useMediaQuery } from '../../hooks'
import { formatGraphData, getAxisDomain } from '../../helpers'

import { GraphPayload } from '../../types'

type Props = {
  data?: GraphPayload
  graphHeight?: number
}

const CPMChart: React.FC<Props> = ({ data, graphHeight }) => {
  const chartRef = useRef<any>(null)
  const [hoveredIndex, handleBarMouseMove, handleBarMouseLeave] = useBarChartHoverIndex()
  const displayType = useMediaQuery()
  const [barSize, onResize] = useBarSize(-45, data?.length)

  const getMonthFormat = () => {
    switch (displayType) {
      case 'mobile':
        return 'one'
      default:
        return 'three'
    }
  }

  const formattedData = formatGraphData('expenses', 15, data, value => Number(value).toFixed(1))
  const domain = getAxisDomain(formattedData, 'expenses')

  return (
    <ResponsiveContainer width={'99%'} height={graphHeight} onResize={onResize}>
      <BarChart
        ref={chartRef}
        data={formattedData}
        barCategoryGap={3}
        maxBarSize={barSize}
        margin={{ top: 0, left: -15, right: 0, bottom: 0 }}
        onMouseMove={handleBarMouseMove}
        onMouseLeave={handleBarMouseLeave}
      >
        <defs>
          <linearGradient id="color-cpm" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#99F0D3" />
            <stop offset="1" stopColor="#B8F5E0" />
          </linearGradient>
          <linearGradient id="colorHovered-cpm" x1="0" y1="0" x2="0" y2="1">
            <stop stopColor="#1CBF89" />
            <stop offset="1" stopColor="#1FD195" />
          </linearGradient>
        </defs>
        {XAxis({ monthFormat: getMonthFormat(), chartType: 'bar', barSize: barSize })}
        {YAxis({ dataKey: 'expenses', unit: '€', domain })}
        <CartesianGrid stroke="#CED8FD" vertical={false} strokeDasharray="5 5" />
        {ChartTooltip({ cursor: false })}
        {Bar({
          dataKey: 'expenses',
          stroke: '#1FD195',
          unit: '€',
          hoveredIndex,
          borderRadius: 15,
          graphData: formattedData,
          color: 'url(#color-cpm)',
          colorHovered: 'url(#colorHovered-cpm'
        })}
      </BarChart>
    </ResponsiveContainer>
  )
}

export default CPMChart
